export default __webpack_public_path__ + "static/media/koushal.cb27c31d.jpeg";